import { useState } from 'react';

// A visitor's draft before signing in: the @ and what it creates about, kept in the
// entry. Once signed in, the @ onboarding turns it into a profile (contract 2.0.0).
export default function useProfileForm(s) {
  const [handle, setHandle] = useState(s.entry.instagram_handle || '');
  const [interests, setInterests] = useState(s.entry.interests || '');
  const [audience, setAudience] = useState(s.entry.audience || '');
  const [voice, setVoice] = useState(s.entry.voice || '');
  const submit = () => {
    s.updateEntry({ instagram_handle: handle.replace(/^@/, ''), interests, audience, voice });
    s.setModal(null);
  };
  return { handle, setHandle, interests, setInterests, audience, setAudience, voice, setVoice, submit };
}
